module.exports = __webpack_public_path__ + "static/img/7.42995b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/7.png
// module id = 6VCr
// module chunks = 0